<template>
  <v-container class="mx-2" fluid>
    <v-row align="center">
      <v-col cols="auto">
        <v-breadcrumbs class="pl-0 pt-0" :items="breadcrumbs" />
      </v-col>
      <v-spacer></v-spacer>
      <v-btn
        right
        color="primary"
        outlined
        class="text-none mr-12"
        dark
        rounded
        @click.prevent="returnController()"
      >
        Просмотр информации
      </v-btn>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card fluid v-if="Object.keys(controllerEdit).length != 0">
          <v-tabs>
            <template v-for="tab in filterTabs()">
              <v-tab v-if="tab.show" :key="tab.name">
                {{ tab.name }}
              </v-tab>
              <v-tab-item
                v-if="tab.show && isDisplayInfoController"
                :key="tab.name"
                class="tab-item pa-5"
              >
                <component
                  v-bind:is="tab.component"
                  :returnController="() => returnController()"
                />
              </v-tab-item>
            </template>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import GeneralInfo from './components/GeneralInfo.vue';

export default {
  name: 'EditController',
  props: ['id'],
  data () {
    return {
      isDisplayInfoController: false,
      breadcrumbs: [
        {
          text: 'Контроллеры',
          disabled: false,
          href: '/controllers',
        },
        {
          text: 'Редактирование',
          disabled: true,
          href: 'breadcrumbs_link_1',
        },
      ],
    };
  },
  created () {
    this.isDisplayInfoController = false;
    this.getControllerInfoEdit({
      id: this.id,
    })
      .then(() => {
        this.isDisplayInfoController = true;
      })
      .catch(() => {
        this.$flash_warning('Ошибка при загрузке информации');
      });
  },

  computed: {
    ...mapGetters({
      controllerEdit: 'Controllers/controllerEdit',
    }),
    tabs () {
      return [
        {
          name: 'Информация',
          component: GeneralInfo,
          route: 'EditControllerGeneralInfoTab',
          show: true,
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      getControllerInfoEdit: 'Controllers/getControllerInfoEdit',
    }),
    returnControllers () {
      this.$router.push({ name: 'Controllers' });
    },
    returnController () {
      this.$router.push({ name: 'DetailController', params: { id: this.$route.params.id } });
    },
    filterTabs () {
      return this.tabs.filter(tab => {
        return this.$canRoute(tab.route);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.info-sound {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
